class Cards {
    expandableCards: NodeListOf<HTMLElement>;

    constructor(){
        this.init();
    }

    init() {
        this.expandableCards = document.querySelectorAll(".expandable-card");

        this.expandableCards.forEach(card => {
            const toggleBtn = card.querySelector('button');
            const cardImg = card.querySelector('img.card-img');
            const cardSummary = card.querySelector('.summary');

            toggleBtn.addEventListener('click', e => {
                cardImg.classList.toggle('opened');
                cardSummary.classList.toggle('d-none');
            })
        })
    }
}

export default Cards;
